import ChevronRightIcon from "@mui/icons-material/ChevronRightRounded";
import { List, ListItemButton, ListItemIcon, ListItemText, ListSubheader } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import useClientContext from "../../contexts/useClientContext";
import { permissionsSelector } from "../../store/state/user/selectors";
import PortalLogoMark from "./PortalLogoMark";

interface Props {
  onNavigate: () => void;
  subheader?: string;
}

const PortalList = ({ onNavigate, subheader }: Props) => {
  const { clientCode } = useClientContext();
  const permissions = useSelector(permissionsSelector);
  const navigate = useNavigate();

  const handleSelect = (targetClientCode: string) => {
    navigate(`/${targetClientCode}`);
    onNavigate();
  };

  return (
    <List
      subheader={
        subheader ? <ListSubheader sx={(theme) => ({ lineHeight: theme.spacing(4) })}>{subheader}</ListSubheader> : null
      }
    >
      {permissions.map((permission) => (
        <ListItemButton
          key={permission.clientCode}
          selected={permission.clientCode === clientCode}
          onClick={() => handleSelect(permission.clientCode)}
        >
          <ListItemIcon sx={(theme) => ({ minWidth: theme.spacing(4) })}>
            <PortalLogoMark logoUrl={permission.portalSettings.logoMarkUrl} title={permission.clientTitle} />
          </ListItemIcon>
          <ListItemText>{permission.clientTitle}</ListItemText>
          <ChevronRightIcon />
        </ListItemButton>
      ))}
    </List>
  );
};

export default PortalList;
